// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KJVg","rootMobile":"styles_rootMobile__3lyAy"};